import React from "react";
import * as S from "../style";
import { Grid } from "@mui/material";
import LineChart from "defaultComponents/Charts/LineCharts/LineChart";
import { IoArrowUp, IoArrowDown } from "react-icons/io5";
import { RiExternalLinkFill } from "react-icons/ri";
import Card from "@mui/material/Card";
import VuiInput from "components/VuiInput";
import Table from "defaultComponents/Tables/Table";

const TiktokVideos = ({ socialData }) => {
  const baseOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      theme: "dark",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "category",
      categories: [],
      labels: {
        formatter: function (val) {
          return new Date(val).toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        },
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      decimalsInFloat: 0,
      floating: false,
      labels: {
        formatter: function (val) {
          return parseFloat(val).toFixed(2) + "%";
        },
        style: {
          colors: "#c8cfca",
          fontSize: "10px",
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      strokeDashArray: 5,
      borderColor: "#56577A",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#65EFAD", "#D7007B"],
    },
    colors: ["#65EFAD", "#D7007B"],
  };
  const [lineChartData, setLineChartData] = React.useState([]);
  const [lineChartOptions, setLineChartOptions] = React.useState({
    ...baseOptions,
  });
  const [reactionsChartData, setReactionsChartData] = React.useState([]);
  const [reactionsChartOptions, setReactionsChartOptions] = React.useState({
    ...baseOptions,
    fill: {
      colors: ["#FC6009", "#F8DF00", "#33CCFF"],
    },
    colors: ["#FC6009", "#F8DF00", "#33CCFF"],
  });
  const [videos, setVideos] = React.useState([]);
  const [filteredVideos, setFilteredVideos] = React.useState([]);
  const [videoSearch, setVideoSearch] = React.useState("");

  React.useEffect(() => {
    try {
      const metrics = socialData?.metrics || [];
      const videos = socialData?.lastVideos || [];

      const options = {
        ...lineChartOptions,
        yaxis: { ...lineChartOptions.yaxis },
        xaxis: { ...lineChartOptions.xaxis },
      };

      const reactionsOptions = {
        ...reactionsChartOptions,
        yaxis: {
          ...reactionsChartOptions.yaxis,
          labels: { ...reactionsChartOptions.yaxis.labels },
        },
        xaxis: { ...reactionsChartOptions.xaxis },
      };

      const getMetricData = (metricName) => {
        const metric = metrics.find((m) => m?.name === metricName);
        return metric?.data || [];
      };

      const reactionsSeries = [
        {
          name: "Likes por vídeo",
          data: getMetricData("tiktok_like_per_post"),
        },
        {
          name: "Comentários por vídeo",
          data: getMetricData("tiktok_comment_per_post"),
        },
        {
          name: "Compartilhamentos por vídeo",
          data: getMetricData("tiktok_share_per_post"),
        },
      ];

      if (metrics?.length > 0) {
        options.xaxis.categories = getMetricData("week");
        setLineChartOptions(options);
        setLineChartData([
          {
            name: "Engajamento",
            data: getMetricData("tiktok_engagement"),
          },
        ]);

        reactionsOptions.xaxis.categories = getMetricData("week");
        const overallMaxValue = reactionsSeries.reduce((max, series) => {
          const seriesMax = Math.max(...series.data.filter((val) => !isNaN(val)));
          return Math.max(max, seriesMax);
        }, 0);

        reactionsOptions.yaxis.max = Math.round(overallMaxValue * 1.2) || 100;
        reactionsOptions.yaxis.labels.formatter = function (val) {
          return parseFloat(val || 0).toFixed(2);
        };

        setReactionsChartOptions(reactionsOptions);
        setReactionsChartData(reactionsSeries);
      }

      if (Array.isArray(videos)) {
        setVideos(videos);
      }
    } catch (error) {
      console.error("Erro ao processar dados do TikTok:", error);
      setVideos([]);
      setLineChartData([]);
      setReactionsChartData([]);
    }
  }, [socialData]);

  React.useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      try {
        let filteredVideos = videos || [];
        if (videoSearch?.trim() !== "") {
          filteredVideos = videos.filter((video) =>
            video?.title?.toLowerCase().includes(videoSearch.toLowerCase())
          );
        }

        setFilteredVideos(
          filteredVideos.map((video) => ({
            Post: (
              <p
                style={{
                  maxWidth: (window?.outerWidth || 1024) * 0.2 + "px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={video?.title || "-"}
              >
                {video?.title || "-"}
              </p>
            ),
            Comentários: video?.comment_count || "-",
            Compartilhamentos: video?.share_count || "-",
            Curtidas: video?.like_count || "-",
            Data: video?.create_time
              ? new Date(video.create_time * 1000).toLocaleDateString("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
              : "-",
          }))
        );
      } catch (error) {
        console.error("Erro ao filtrar vídeos:", error);
        setFilteredVideos([]);
      }
    }, 1000);

    return () => clearTimeout(debounceTimeout);
  }, [videos, videoSearch]);
  return (
    <Grid container spacing="18px">
      <Grid item xs={12} lg={12} xl={12}>
        <Card>
          <Grid display="flex" gap="30px" flexDirection="column">
            <Grid>
              <Grid container justifyContent="space-between">
                <Grid item xl={4}>
                  <p style={{ color: "white" }}>Engajamento por visualização</p>
                </Grid>
                <Grid container item xl={8} justifyContent="flex-end">
                  <S.BlocksGrid container item xl={12}>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <p>
                        {socialData?.engagement
                          ? String(Number(socialData?.engagement).toFixed(2) + "%")
                          : "-"}
                      </p>
                      <p className="subTitle">Engajamento</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>{socialData?.interactions ? socialData?.interactions : "-"}</p>
                        {socialData?.interactions && socialData?.interactions >= 0 ? (
                          <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                        ) : (
                          <IoArrowDown
                            color="#D7007B"
                            size="16px"
                            style={{ alignSelf: "center" }}
                          />
                        )}
                      </Grid>
                      <p className="subTitle">Interações</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>
                          {socialData?.interactionsPerPost
                            ? Number(socialData?.interactionsPerPost).toFixed(2)
                            : "-"}
                        </p>
                        {socialData?.interactionsPerPostTrend &&
                        socialData?.interactionsPerPostTrend == "up" ? (
                          <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                        ) : (
                          <IoArrowDown
                            color="#D7007B"
                            size="16px"
                            style={{ alignSelf: "center" }}
                          />
                        )}
                      </Grid>
                      <p className="subTitle">Int. por Post</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>{socialData?.impressions ? socialData?.impressions : "-"}</p>
                        <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                      </Grid>
                      <p className="subTitle">Impressões</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <p>{socialData?.posts ? socialData?.posts : "-"}</p>
                      <p className="subTitle">Posts</p>
                    </S.PostsBlock>
                  </S.BlocksGrid>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={{ minHeight: "300px" }}>
              <LineChart lineChartData={lineChartData} lineChartOptions={lineChartOptions} />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} lg={12} xl={12}>
        <Card>
          <Grid display="flex" gap="30px" flexDirection="column">
            <Grid>
              <Grid container justifyContent="space-between">
                <Grid item xl={4}>
                  <p style={{ color: "white" }}>Vídeos</p>
                </Grid>
                <Grid container item xl={8} justifyContent="flex-end" gap="10px">
                  <S.BlocksGrid container item xl={12}>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>{socialData?.likes ? socialData?.likes : "-"}</p>
                        {socialData?.likesTrend == "up" ? (
                          <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                        ) : (
                          <IoArrowDown
                            color="#D7007B"
                            size="16px"
                            style={{ alignSelf: "center" }}
                          />
                        )}
                      </Grid>
                      <p className="subTitle">Likes</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>{socialData?.comments ? socialData?.comments : "-"}</p>
                        {socialData?.commentsTrend == "up" ? (
                          <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                        ) : (
                          <IoArrowDown
                            color="#D7007B"
                            size="16px"
                            style={{ alignSelf: "center" }}
                          />
                        )}
                      </Grid>
                      <p className="subTitle">Comentários</p>
                    </S.PostsBlock>
                    <S.PostsBlock item xs={1.5} xl={2}>
                      <Grid container justifyContent="center">
                        <p>{socialData?.shares ? socialData?.shares : "-"}</p>
                        {socialData?.sharesTrend == "up" ? (
                          <IoArrowUp color="#65EFAD" size="16px" style={{ alignSelf: "center" }} />
                        ) : (
                          <IoArrowDown
                            color="#D7007B"
                            size="16px"
                            style={{ alignSelf: "center" }}
                          />
                        )}
                      </Grid>
                      <p className="subTitle">Compartilhamentos</p>
                    </S.PostsBlock>
                  </S.BlocksGrid>
                </Grid>
              </Grid>
            </Grid>
            <Grid sx={{ minHeight: "300px" }}>
              <LineChart
                lineChartData={reactionsChartData}
                lineChartOptions={reactionsChartOptions}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} lg={12} xl={12}>
        <Card>
          <Grid>
            <Grid container justifyContent="space-between">
              <Grid item>
                <p style={{ color: "#fff" }}>Lista de Posts</p>
              </Grid>
              <Grid item xl={2}>
                <VuiInput
                  placeholder="Buscar..."
                  icon={{ component: "search", direction: "left" }}
                  sx={({ breakpoints }) => ({
                    [breakpoints.down("sm")]: {
                      maxWidth: "80px",
                    },
                    [breakpoints.only("sm")]: {
                      maxWidth: "80px",
                    },
                    backgroundColor: "info.main !important",
                  })}
                  onChange={(e) => setVideoSearch(e?.target?.value ?? "")}
                />
              </Grid>
            </Grid>
            <S.TableGrid>
              <Table
                columns={[
                  { name: "Post", align: "left" },
                  { name: "Comentários", align: "center" },
                  { name: "Compartilhamentos", align: "center" },
                  { name: "Curtidas", align: "center" },
                  { name: "Data", align: "center" },
                ]}
                rows={filteredVideos}
              />
            </S.TableGrid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TiktokVideos;
